import SubCategorySimpleView from './SubCategorySimpleView'

export default SubCategorySimpleView
